import { render, staticRenderFns } from "./ConfiguratorHeadlightBlock.vue?vue&type=template&id=d7d7427e"
import script from "./ConfiguratorHeadlightBlock.vue?vue&type=script&lang=js"
export * from "./ConfiguratorHeadlightBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default})
